import isEmpty from "lodash/isEmpty";
import { apiSlice, asyncToastDisplay, i18n } from "./apiSlice";

const prepareParams = function({ page = 1, perPage = 30, filters, sortBy}) {
  let params = { page: page, per_page: perPage };
  if (sortBy && sortBy[0]) {
    params.sort_by = sortBy[0].id;
    params.sort_desc = sortBy[0].desc;
  }
  if (!isEmpty(filters)) {
    params.filters = JSON.stringify(filters.reduce((acc, filter) => {
      return {
        ...acc,
        [filter.id]: filter.value
      }
    }, {}))
  }
  return params;
}

export const deviceApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getDevices: builder.query({
      query: (params) => {
        return {
          url: `/devices/`,
          params: prepareParams(params)
        }
      },
      providesTags: (result, error, arg) => [{ type: 'Device', id: `LIST:${JSON.stringify(arg)}` }],
    }),
    getDevice: builder.query({
      query: (sptId) => {
        return {
          url: `/devices/${sptId}`,
        }
      },
      providesTags: (result, error, arg) => [{ type: 'Device', id: arg }],
    }),
    getMonitoredDevice: builder.query({
      query: (sptId) => {
        return {
          url: `/devices/${sptId}/monitored_device`,
        }
      },
      providesTags: (result, error, arg) => [{ type: 'Device', id: `Monitor:${arg}` }],
    }),
    getMonitoredDeviceUsers: builder.query({
      query: (sptId) => {
        return {
          url: `/devices/${sptId}/monitored_device/users`,
        }
      },
      providesTags: (result, error, arg) => [{ type: 'Device', id: 'Users' }],
    }),
    updateMonitoredDevice: builder.mutation({
      query: (monitored) => ({
        url: (`/devices/${monitored.sptId}/monitored_device`),
        method: 'PUT',
        body: monitored,
      }),
      onQueryStarted: asyncToastDisplay({successMessage: i18n.t("toast.updated")}),
      invalidatesTags: (result, error, arg) => ['Device']
    }),
    deleteMonitoredDevice: builder.mutation({
      query: (sptId) => ({
        url: (`/devices/${sptId}/monitored_device`),
        method: 'DELETE',
      }),
      onQueryStarted: asyncToastDisplay({successMessage: i18n.t("toast.deleted")}),
      invalidatesTags: (result, error, arg) => ['Device']
    }),
  }),
  overrideExisting: false
})

export const {
  useLazyGetDevicesQuery,
  useGetDeviceQuery,
  useGetMonitoredDeviceQuery,
  useGetMonitoredDeviceUsersQuery,
  useUpdateMonitoredDeviceMutation,
  useDeleteMonitoredDeviceMutation
} = deviceApiSlice
